import { Typography } from "@material-ui/core"

const Base = (props) => {

  return ( <>
    <Typography>
      Once we’ve started working on your song, we can’t offer refunds—our lyricists and musicians put real time and effort into crafting something unique just for you! But if you’re unhappy with the final result, we do offer discounts for revisions or starting over with new lyrics. If you have any concerns, reach out, and we’ll do our best to make things right!
    </Typography>
  </> )
}

export default Base
